/**
 * @fileoverview Interpret browser/build runtime environment for application presentation, including favicon identity. Runtime configuration and hostname are inputs to this display boundary. Protected backend operations use their own environment/admission checks; a browser label is not proof of production safety or feature activation.
 */

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);



function normalizeAppEnvironment(value) {
  const normalized = String(value || '').trim().toLowerCase();

  if (normalized === 'development' || normalized === 'staging' || normalized === 'production') {
    return normalized;
  }

  return '';
}



export function getAppEnvironment({
  runtimeConfig = window.__KC_RUNTIME_CONFIG__,
  location = window.location,
} = {}) {
  const configuredEnvironment = normalizeAppEnvironment(runtimeConfig?.appEnvironment);

  if (configuredEnvironment) {
    return configuredEnvironment;
  }

  const hostname = String(location?.hostname || '').trim().toLowerCase();
  if (LOCAL_HOSTNAMES.has(hostname) || hostname.endsWith('.local')) {
    return 'development';
  }

  return 'production';
}



export function getEnvironmentFaviconHref(
  appEnvironment,
  publicUrl = process.env.PUBLIC_URL || ''
) {
  if (appEnvironment === 'development') {
    return `${publicUrl}/favicon-local.png`;
  }

  if (appEnvironment === 'staging') {
    return `${publicUrl}/favicon-staging.png`;
  }

  return `${publicUrl}/favicon.ico`;
}



function upsertFaviconLink(doc, rel, href) {
  let link = doc.querySelector(`link[rel="${rel}"]`);

  if (!link) {
    link = doc.createElement('link');
    link.setAttribute('rel', rel);
    doc.head.appendChild(link);
  }

  const isPng = href.endsWith('.png');
  link.setAttribute('type', isPng ? 'image/png' : 'image/x-icon');
  link.setAttribute('href', href);
}



export function applyEnvironmentFavicon({
  doc = document,
  runtimeConfig,
  location,
  publicUrl,
} = {}) {
  if (!doc?.head) {
    return null;
  }

  const appEnvironment = getAppEnvironment({ runtimeConfig, location });
  const href = getEnvironmentFaviconHref(appEnvironment, publicUrl);

  upsertFaviconLink(doc, 'icon', href);
  upsertFaviconLink(doc, 'shortcut icon', href);

  return href;
}
